import React from 'react';
import audioLink from '../../../../assets/audios/newMessage.mp3';
import ImageIcon from '../../../../assets/img/message.png';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import ToastFlex from 'utils/classes/ToastFlex';

const ClickToastArea = ({
  name,
  idChat,
  IsNotificationScheduling,
  IsNotificationSchedulingCrm
}) => {
  const history = useHistory();

  const handlerClick = async (idChat) => {
    if (IsNotificationScheduling) {
      history.push(`/admin/protocol`, {
        idChat,
        IsNotificationScheduling: true
      });
    } else if (IsNotificationSchedulingCrm) {
      if (IsNotificationSchedulingCrm?.entity) {
        const { entity, recordTypeId, leadId, opportunityId } =
          IsNotificationSchedulingCrm;

        const basePath = `/admin/crm`;
        const paths = {
          LEAD:
            leadId && recordTypeId
              ? `${basePath}/leadEdit/${recordTypeId}/${leadId}`
              : `${basePath}/lead`,
          OPPORTUNITY:
            opportunityId && recordTypeId
              ? `${basePath}/opportunityEdit/${recordTypeId}/${opportunityId}`
              : `${basePath}/opportunity`
        };

        const path = paths[entity] || basePath;

        history.push(path);
      }
    } else {
      history.push(`/admin/service_panel`, { idChat });
    }
  };

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        padding: '10px'
      }}
      onClick={() => {
        handlerClick(idChat)
          .then(() => {})
          .catch((error) => {
            console.log('error ==>', error);
          });
      }}
    >
      {name}
    </div>
  );
};

export const PlayNewAlert = (
  data,
  permission,
  type,
  audioNotification,
  IsNotificationScheduling = false,
  message = null,
  typeToast = 'INFO'
) => {
  if (IsNotificationScheduling) {
    if (data?.entity || data?.type === 'scheduling_crm') {
      let audio = new Audio(audioLink);

      const dateObject = new Date(data.createdAt);
      const offsetHours = dateObject.getUTCHours() - 3;
      const minutes = dateObject.getUTCMinutes();
      const matchTitle = data.content.match(
        /(Lead|Oportunidade) ([^p]+)(para o dia|para agora)/
      );

      const title = matchTitle ? matchTitle[2].trim() : '';

      const adjustedHours = (offsetHours + 24) % 24;

      const formattedTime = `${String(adjustedHours).padStart(2, '0')}:${String(
        minutes
      ).padStart(2, '0')}`;

      const audioNotificationVolume =
        localStorage.getItem('@flexuc/audioNotificationVolume') || 1;

      audio.volume = audioNotificationVolume;

      const menssageBody = `Você tem um agendamento às ${formattedTime}h referente ${
        data?.entity === 'LEAD'
          ? `ao Lead ${title}.`
          : `à Oportunidade ${title}.`
      }`;

      const audioEnabled = JSON.parse(
        localStorage.getItem('@flexuc/audioEnabled')
      );

      if (permission === 'granted') {
        const notification = new Notification('FlexUC', {
          body: menssageBody,
          icon: ImageIcon
        });
        const origin = window.location.origin;
        if (data.entity === 'LEAD') {
          notification.onclick = function () {
            window.open(
              `${origin}/admin/crm/leadEdit/${data.recordTypeId}/${data.leadId}`,
              '_blank'
            );
            window.focus();
          };
        } else if (data.entity === 'OPPORTUNITY') {
          notification.onclick = function () {
            window.open(
              `${origin}/admin/crm/opportunityEdit/${data.recordTypeId}/${data.opportunityId}`,
              '_blank'
            );
            window.focus();
          };
        }
      } else {
        toast.info(
          <ClickToastArea
            name={menssageBody}
            IsNotificationSchedulingCrm={data}
          />
        );
      }
      if (audioEnabled) audio.play();
    } else {
      let audio = new Audio(audioLink);

      const dateObject = new Date(data.createdAt);
      const offsetHours = dateObject.getUTCHours() - 3;
      const minutes = dateObject.getUTCMinutes();

      const adjustedHours = (offsetHours + 24) % 24;

      const formattedTime = `${String(adjustedHours).padStart(2, '0')}:${String(
        minutes
      ).padStart(2, '0')}`;

      const protocoloRegex = /Protocolo N° (\d+)/;

      const match = data?.content.match(protocoloRegex);
      const protocoloNumber = match ? match[1] : null;

      const audioNotificationVolume =
        localStorage.getItem('@flexuc/audioNotificationVolume') || 1;

      audio.volume = audioNotificationVolume;

      const menssageBody = `Você tem um agendamento às ${formattedTime}h referente ao protocolo N° ${protocoloNumber} `;

      const audioEnabled = JSON.parse(
        localStorage.getItem('@flexuc/audioEnabled')
      );

      if (permission === 'granted') {
        const notification = new Notification('FlexUC', {
          body: menssageBody,
          icon: ImageIcon
        });
        const origin = window.location.origin;
        notification.onclick = function () {
          window.open(
            `${origin}/admin/protocol/${data.protocolId}/update`,
            '_blank'
          );
          window.focus();
        };
      } else {
        toast.info(
          <ClickToastArea
            name={menssageBody}
            idChat={data.protocolId}
            IsNotificationScheduling={true}
          />
        );
      }
      if (audioEnabled) audio.play();
    }
  } else {
    const idDaConversa = data?.idDaConversa || data?.id || data?._id;
    let audio = new Audio(audioLink);
    if (audioNotification !== null && audioNotification !== undefined) {
      audio = new Audio(audioNotification);
    }

    const title = () => {
      if (type === 'client_in_queue') {
        return `O cliente ${data?.cliente?.nome} entrou na fila ${data?.fila}`;
      } else if (type === 'new_message') {
        return `Cliente ${data?.mensagem?.escrita_por} envio uma mensagem`;
      } else if (type === 'exclusive_conversation') {
        return `Você recebeu uma nova conversa`;
      }
    };

    const messageAlert = message || title();
    const audioNotificationVolume =
      localStorage.getItem('@flexuc/audioNotificationVolume') || 1;
    const toastPermission = localStorage.getItem(
      '@flexuc/isNotificationsChatEnabled'
    );

    audio.volume = audioNotificationVolume;

    const audioEnabled = JSON.parse(
      localStorage.getItem('@flexuc/audioEnabled')
    );

    if (permission === 'granted') {
      const notification = new Notification('FlexUC', {
        body: messageAlert,
        icon: ImageIcon
      });
      const origin = window.location.origin;

      notification.onclick = function () {
        window.open(`${origin}/admin/service_panel/${idDaConversa}`, '_blank');
        window.focus();
      };
    } else {
      ToastFlex.info(
        <ClickToastArea name={messageAlert} idChat={idDaConversa} />,
        toastPermission === 'true',
        data?.action,
        null
      );
    }
    if (audioEnabled) audio.play();
  }
};
